import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { database } from '../firebase/config';
import CaricaGiornaliera from './dipendente/CaricaGiornaliera';
import CaricaFotoCantiere from './dipendente/CaricaFotoCantiere';
import CreaBollaForm from './dipendente/CreaBollaForm';
import MieBolleForm from './dipendente/MieBolleForm';
import MieGiornaliereForm from './dipendente/MieGiornaliereForm';
import '../styles/Dashboard.css';

function DipendenteDashboard() {
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();
  const [sezioneAttiva, setSezioneAttiva] = useState(null);
  const [dipendente, setDipendente] = useState(null);

  // Carica il record dipendente collegato all'utente loggato
  useEffect(() => {
    async function caricaDipendente() {
      if (!currentUser) return;
      // Recupera il dipendenteId dal nodo users/
      const userRef = ref(database, `users/${currentUser.uid}`);
      const userSnap = await get(userRef);
      if (!userSnap.exists()) return;
      const { dipendenteId } = userSnap.val();
      // Carica il record dipendente
      const dipSnap = await get(ref(database, `dipendenti/${dipendenteId}`));
      if (dipSnap.exists()) {
        setDipendente({ id: dipendenteId, ...dipSnap.val() });
      }
    }
    caricaDipendente();
  }, [currentUser]);

  async function handleLogout() {
    try {
      await logout();
      navigate('/');
    } catch {
      alert('Errore durante il logout');
    }
  }

  // Se una sezione è attiva, renderizza il componente corrispondente


if (sezioneAttiva === 'creaBolla') {
  return (
    <div>
      <button className="btn-back-mobile" onClick={() => setSezioneAttiva(null)}>← Home</button>
      <CreaBollaForm
  dipendente={dipendente}
  onBack={() => setSezioneAttiva(null)}
  onBollaSalvata={() => setSezioneAttiva('mieBolleForm')}
/>
    </div>
  );
}


if (sezioneAttiva === 'mieBolleForm') {
  return <MieBolleForm dipendente={dipendente} onBack={() => setSezioneAttiva(null)} />;
}

if (sezioneAttiva === 'mieGiornaliere') return <MieGiornaliereForm dipendente={dipendente} onBack={() => setSezioneAttiva(null)} />;

if (sezioneAttiva === 'giornaliera') {
  return (
    <div>
      <button className="btn-back-mobile" onClick={() => setSezioneAttiva(null)}>← Home</button>
      <CaricaGiornaliera
        dipendente={dipendente}
        onBack={() => setSezioneAttiva(null)}
      />
    </div>
  );
}
if (sezioneAttiva === 'foto') {
  return (
    <div>
      <button className="btn-back-mobile" onClick={() => setSezioneAttiva(null)}>← Home</button>
      <CaricaFotoCantiere
        dipendente={dipendente}
        onBack={() => setSezioneAttiva(null)}
      />
    </div>
  );
}


if (sezioneAttiva === 'mieBolle') {
  return (
    <MieBolleForm
      dipendente={dipendente}
      onBack={() => setSezioneAttiva(null)}
    />
  );
}


  // Schermata principale dipendente
  return (
    <div className="dashboard-container">
      <button className="btn-esci-mobile" onClick={handleLogout}>ESCI</button>
      <div className="sidebar">
        <h2><img src="/CRG_logo.png" alt="crg" style={{ width: '150px' }} /></h2>
        <div className="user-info">
          <p>
            {dipendente
              ? `${dipendente.nome} ${dipendente.cognome}`
              : 'Dipendente'}
          </p>
          <small>{currentUser?.email}</small>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          ESCI
        </button>
      </div>

      <div className="main-content">

        <div className="content-body">
          <div className="welcome-section">
            <h2>
              Benvenuto{dipendente ? `, ${dipendente.nome}` : ''}!
            </h2>
            <p>Seleziona cosa vuoi caricare oggi.</p>
            <p>v{process.env.REACT_APP_VERSION || '—'}</p>
          </div>

{/* 4 pulsanti principali */}
<div className="azioni-dipendente">


  <div className="azione-card" onClick={() => setSezioneAttiva('creaBolla')}>
    <div className="azione-icon">✍️</div>
    <div className="azione-label">Crea Bolla</div>
    <div className="azione-desc">
      Compila la bolla di lavoro digitale con firma cliente
    </div>
  </div>

<div className="azione-card" onClick={() => setSezioneAttiva('mieBolle')}>
  <div className="azione-icon">📋</div>
  <div className="azione-label">Le mie bolle</div>
  <div className="azione-desc">
    Visualizza e condividi le bolle create
  </div>
</div>

  <div className="azione-card" onClick={() => setSezioneAttiva('foto')}>
    <div className="azione-icon">📷</div>
    <div className="azione-label">Carica Foto Cantiere</div>
    <div className="azione-desc">
      Carica fino a 2 foto per cantiere al giorno
    </div>
  </div>


  <div className="azione-card" onClick={() => setSezioneAttiva('giornaliera')}>
    <div className="azione-icon">📆</div>
    <div className="azione-label">Carica Giornaliera</div>
    <div className="azione-desc">
      Carica il tuo report giornaliero
    </div>
  </div>

<div className="azione-card" onClick={() => setSezioneAttiva('mieGiornaliere')}>
  <div className="azione-icona"></div>
  <div className="azione-label">Le mie giornaliere</div>
  <div className="azione-desc">Visualizza e modifica le tue giornaliere</div>
</div>

</div>
        </div>
      </div>
    </div>
  );
}

export default DipendenteDashboard;
